import React from "react";

import { useDecodedAuthPrincipal } from "AuthPrincipal";

declare global {
  interface Window {
    hj?: any;
    _hjSettings?: any;
  }
}

export const useHotjar = () => {
  const principal = useDecodedAuthPrincipal();
  React.useEffect(() => {
    const hjid = process.env.REACT_APP_HOTJAR_ID
      ? parseInt(process.env.REACT_APP_HOTJAR_ID)
      : undefined;
    const hjsv = process.env.REACT_APP_HOTJAR_SNIPPET_VERSION
      ? parseInt(process.env.REACT_APP_HOTJAR_SNIPPET_VERSION)
      : undefined;

    if (principal?.account.isPro && hjid && hjsv) {
      /**
       * Hotjar Initialize
       *
       * This code calls the hotjar initialize script. This code has been
       * modified to run in react-land instead of inside a script header like
       * the installation guide would suggest.
       *
       * read more:
       * https://help.hotjar.com/hc/en-us/articles/115009336727?itm_source=insights_installation_help
       */
      window.hj =
        window.hj ??
        function () {
          (window.hj.q = window.hj.q || []).push(arguments);
        };
      window._hjSettings = { hjid, hjsv };
      const scriptElement = document.createElement("script");
      scriptElement.async = true;
      scriptElement.src = `https://static.hotjar.com/c/hotjar-${hjid}.js?sv=${hjsv}`;
      scriptElement.onload = () => {
        /**
         * Hotjar Identify
         *
         * This code calls the hotjar identify api with a user id and
         * object containing user properties.
         *
         * read more:
         * https://help.hotjar.com/hc/en-us/articles/360033640653-Identify-API-Reference
         */
        const uid = principal.user.email ?? principal.user.id;
        window.hj("identify", uid, { principal });
      };
      document.head.appendChild(scriptElement);
      return () => {
        document.head.removeChild(scriptElement);
      };
    }
  }, [principal]);
};
